import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category/all", label: "全部漫画" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-none" : "bg-transparent"
      }`}
    >
      <nav className="w-full mx-auto px-4 md:px-6 h-16 flex items-center justify-between" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="36漫画网 首页">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">
            漫
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-900 whitespace-nowrap">
            36漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === l.to
                  ? "text-primary-600"
                  : "text-foreground-700 hover:text-primary-600"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <div className="relative">
            <button
              type="button"
              onClick={() => setCatOpen((v) => !v)}
              className="px-4 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer"
              aria-haspopup="true"
              aria-expanded={catOpen}
            >
              漫画分类
              <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform ${catOpen ? "rotate-180" : ""}`} aria-hidden="true" />
            </button>
            {catOpen && (
              <div className="absolute right-0 mt-2 w-52 rounded-lg bg-background-50 border border-background-200/70 p-2 shadow-none">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900 transition-colors"
                  >
                    <i className={`${c.icon} w-4 h-4 flex items-center justify-center text-primary-600`} aria-hidden="true" />
                    {c.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium px-4 py-2 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            开始阅读
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl w-6 h-6 flex items-center justify-center`} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100"
            >
              {l.label}
            </Link>
          ))}
          <p className="px-3 pt-2 pb-1 text-xs text-foreground-500 font-medium">漫画分类</p>
          <div className="grid grid-cols-2 gap-1">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-secondary-100"
              >
                <i className={`${c.icon} w-4 h-4 flex items-center justify-center text-primary-600`} aria-hidden="true" />
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}